export default "__VITE_PUBLIC_ASSET__d383cd7f__"